import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Input,
  Card,
  CardBody,
  CardHeader,
  Table,
  CardText,
} from "reactstrap";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
} from "../global/browserFunctions";
import Icon from "./Icon";
import { cartUrl } from "../global/url";
import {
  showNotification,
  noDismissNotification,
} from "../global/notification";
import jquery from "jquery";
import Loader from "../components/Loader";
import _ from "underscore";

class CheckoutSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      loading: false,
      subtotal: 0,
      shipping: 0,
      total:0,
      tax:0,
      summary: props.summary
    };
    this.priceLevel = "1";
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.setData();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.summary != nextProps.summary) {
     this.setState({summary: nextProps.summary}, function(){
      
       var summary= nextProps.summary;
       this.setState({subtotal: summary.subtotal.text || 0})
       this.setState({total: summary.total.text || 0})
       this.setState({shipping: summary.shippingcost.text || 0})
       this.setState({tax: summary.taxtotal.text || 0})
       this.forceUpdate();
      })
      return true;
    }
    return false;
  }

  setData() {
    var query = "&method=fetch&customer=";
    var customer = getCookie("customid");
    query += customer;
    var self = this;
    jquery
      .ajax({
        url: cartUrl + query,
        Cache: false,
        dataType: "jsonp",
      })
      .done(function (data) {
        self.setState({ loading: false });
        try {
          data = JSON.parse(decodeURIComponent(data));
          
          if (data.summary && data.summary.status == "SUCCESS") {
            var items = data.summary.data || [];
            for (var i in items) {
              var matrixOption = JSON.parse(items[i].metrixOption || {});
              items[i] = _.extend(items[i], matrixOption);
            }
            self.setState({ items: items }, function () {
              self.setSubTotal();
            });
          } else {
            setCookie("cartCount", 0);
          }
        } catch (error) {
          console.log("err@fectchcart", error);
        }
      })
      .fail(function () {
        self.setState({ loading: false });
        showNotification(
          "Sorry",
          "danger",
          "An unknown error occurred. Couldn't fetch cart info"
        );
      });
  }

  setSubTotal() {
    var items = [...this.state.items];
    var total = 0;
    for (var i in items) {
      var qty = parseInt(items[i].itemQuantity || 0);
      var price = items[i].pricelevelAmount;
      total = total + qty * price;
    }
    total = total + this.state.shipping;
    total = total.toFixed(2);
    this.setState({ subtotal: total });
  }

  render() {
    return (
      <React.Fragment>
        <Loader loading={this.state.loading} />
        <Card className="mb-5">
          <CardHeader>
            <h4 className="mb-0 mt-2">Order Summary</h4>
          </CardHeader>
          <CardBody className="py-4">
            <CardText tag="table" className="table">
              <tbody>
                <tr>
                  <th className="py-4">Subtotal</th>
                  <td className="py-4 text-right text-muted">
                    ${this.state.subtotal}
                  </td>
                </tr>
                <tr>
                  <th className="py-4">Tax</th>
                  <td className="py-4 text-right text-muted">
                    ${this.state.tax}
                  </td>
                </tr>
                <tr>
                  <th className="py-4">Shipping</th>
                  <td className="py-4 text-right text-muted">
                    ${this.state.shipping}
                  </td>
                </tr>
                <tr>
                  <th className="pt-4">Total</th>
                  <td className="pt-4 text-right h3 font-weight-normal">
                    ${this.state.total}
                  </td>
                </tr>
              </tbody>
            </CardText>
          </CardBody>
        </Card>

        <Card className="mb-5">
          <CardHeader>
            <h4 className="mb-0 mt-2">Cart Summary</h4>
          </CardHeader>
          <CardBody className="py-4">
            <CardText tag="table" className="cart-body">
            {this.state.items.map((item, index) => (
												<div key={index} className='cart-item'>
													<Row className='d-flex align-items-center text-left'>
														<Col xs='12' md='12'>
															<div className='d-flex align-items-center'>
															
																	<img
																		className='cart-item-img'
																		src={item.imageUrl}
																		alt='Item Image'
																	/>


																<div className='cart-title text-left'>
																
																		<strong>
																			{item.name}
																		</strong>

																</div>
															</div>
														</Col>
														<Col xs='12' md='12' className='mt-4 mt-md-0'>
															<Row className='align-items-center mr-0'>
																<Col xs='12'>
																	<Row>
																		<Col
																			xs='6'
																			className='text-muted'
																		>
																			Price
																		</Col>
																		<Col
																			xs='6'
																			className='text-right'
																		>
																			$
																			{item.pricelevelAmount}
																		</Col>
																	</Row>
																</Col>
																<Col xs='12'>
																	<Row className='align-items-center'>
																		<Col
																			xs='7'
																			className='text-muted'
																		>
																			Quantity
																		</Col>
																		<Col
																			xs='5'
																			className='text-right'
																		>
																			{item.itemQuantity}
																		</Col>
																	</Row>
																</Col>
																<Col xs='12'>
																	<Row>
																		<Col
																			xs='6'
																			className=' text-muted'
																		>
																			Total price
																		</Col>
																		<Col
																			xs='6'
																			className='text-right'
																		>
																			 ${(
                                item.pricelevelAmount * item.itemQuantity
                              ).toFixed(2)}
																		</Col>
																	</Row>
																</Col>
															</Row>
														</Col>
													</Row>
												</div>
											))}
            </CardText>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default CheckoutSummary;
